import { useEffect, useState } from 'react'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { HealthToolInfoApi } from 'interfaces/types'

type UseMyHealthArgs = {
  initLoad?: boolean
}

type UseMyHealthReturn = {
  healthData: HealthToolInfoApi | null
  isMyHealthDataLoading: boolean
  reloadMyHealthData: () => void
}

export const useMyHealth = ({
  initLoad = true,
}: UseMyHealthArgs): UseMyHealthReturn => {
  const [healthData, setHealthData] = useState<HealthToolInfoApi | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [willLoad, setWillLoad] = useState<boolean>(initLoad)

  useEffect(() => {
    if (willLoad) {
      ;(async () => {
        setLoading(true)
        const healthDataRes = await callApiNew(
          PATHS.SIDIS.GET_SIDIS_HEALTH_INFO,
          undefined,
          'sidis_frontend',
        )

        setHealthData(healthDataRes?._data || null)
        setLoading(false)
      })()

      setWillLoad(false)
    }
  }, [willLoad])

  return {
    healthData,
    isMyHealthDataLoading: loading,
    reloadMyHealthData: () => setWillLoad(true),
  }
}
